<template>
  <div class="relative mb-8 md:mt-0 border border-solid border-gray-light bg-white lg:border-0 rounded-[4px]">
    <!-- Mobile Navigation Button -->
    <button
      @click="$emit('toggle')"
      class="relative z-50 flex w-full items-center gap-2 rounded-[4px] bg-white px-4 py-2 ring-1 ring-gray-light lg:hidden"
    >
      <div class="flex-start flex flex-col gap-1 text-left tracking-wider">
        <span class="bold font-extralight font-neue-kabel text-[8px] uppercase text-dark-turquoise">
          Meny
        </span>
        <span class="font-bold tracking-tight">Mina sidor</span>
      </div>
      <span class="ml-auto">
        <span v-if="!isOpen">
          <IconChevronDown class="text-[#337690] w-6 h-6" />
        </span>
        <span v-else>
          <IconChevronUp class="text-[#337690] w-6 h-6" />
        </span>
      </span>
    </button>

    <!-- Backdrop for mobile -->
    <transition name="fade">
      <div
        v-if="isOpen"
        @click="$emit('toggle')"
        class="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
      ></div>
    </transition>

    <!-- Mobile Navigation Content -->
    <transition name="slide">
      <nav v-show="isOpen" class="absolute left-0 right-0 z-50 lg:relative lg:col-span-3 lg:block">
        <ul class="relative z-50 rounded-b-sm bg-white ring-1 ring-gray-light lg:rounded-xl">
          <slot></slot>
        </ul>
      </nav>
    </transition>

    <!-- Desktop Navigation (Always Visible) -->
    <nav class="hidden lg:block bg-background xl:min-w-[333px]">
      <ul class="relative rounded-[10px] bg-white ring-gray-light overflow-hidden"
          :class="{ 'ring-1': authStatus }">
        <slot></slot>
      </ul>
    </nav>
  </div>
</template>

<script>
import IconChevronDown from '@/components/icons/IconChevronDown';
import IconChevronUp from '@/components/icons/IconChevronUp';

export default {
  name: 'MobileMenu',
  components: { IconChevronDown, IconChevronUp },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    authStatus: {
      type: Boolean,
      required: true,
    }
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
